import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyWithoutToken = microserviceNames.stakeholderMicroserviceWithoutToken;
const proxy = microserviceNames.stakeholderMicroservice;

export async function submitGradeApplication(form, mode) {
    return (await Axios.post(`${proxyWithoutToken}/${Urls.GradeApplication}?mode=${mode}`, form)).data;
}

export async function getGradeApplicationByStakeholderId(stakeholderId) {
    return (await Axios.get(`${proxy}/${Urls.GradeApplication}/${stakeholderId}`)).data;
}

export async function upgrade(form, mode) {
    return (await Axios.post(`${proxy}/${Urls.GradeApplication}/upgrade?mode=${mode}`, form)).data;
} // Sinifler arasinda upgrade gedende

export async function edit(id, form) {
    return (await Axios.put(`${proxy}/${Urls.GradeApplication}/${id}`, form)).data;
} // sinifin icinde edit/update gedende